import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import HeaderNonSrp from "../header/headerNonSrp";
import SubHeader from "../header/subHeader";
import Footer from "../footer/footer";
import MenuList from "./MenuList";
import History from "./History";
import KeyStatistics from "./KeyStatistics";
import InfrastructureFacility from "./InfrastructureFacility";
import AnnualAdministrationReport from "./AnnualAdministrationReport";
import ItInKsrtc from "./ItInKsrtc";
import FinancialPerformance from "./FinancialPerformance";
import LabourWelfare from "./LabourWelfare";
import Procurement from "./Procurement";
import PassengerSafety from "./PassengerSafety";
import Management from "./Management";
import RtiAct from "./RtiAct";
import Awards from "./Awards";
import Gst from "./Gst";
import LettersNCirculars from "./LettersNCirculars";
import LuggageRates from "./LuggageRates";
import ReservationTerms from "./ReservationTerms";
import GuestUsersTerms from "./GuestUsersTerms";
import GuestUsersTermsKn from "./GuestUsersTerms-kn";
import RefundRulesAndClaims from "./RefundRulesAndClaims";
import RefundRulesAndClaimsKn from "./RefundRulesAndClaimsKn";
import BookingCounters from "./BookingCounters";
import BookingCountersKn from "./BookingCountersKn";
import PassesNConcession from "./PassesNConcession";
import PassesNConcessionKn from "./PassesNConcessionKn";
import SakalaServices from "./SakalaServices";
import SakalaServicesKn from "./SakalaServicesKn";
import StudentPass from "./StudentPass";
import StudentPassKn from "./StudentPassKn";
import BusServices from "./BusServices";
import SutpIts from "./SutpIts";
import MorthProject from "./MorthProject";
import MorthProjectKn from "./MorthProjectKn";

import CasualContact from "./CasualContact";
import CasualContactKn from "./CasualContactKn";
import NewFranchisee from "./NewFranchisee";
import NewFranchiseeKn from "./NewFranchiseeKn";
import Feedback from "../feedback/Feedback";

const index = (props) => {
  const { location } = props;
  const { pathname } = location;

  const [currentMenu, setCurrentMenu] = useState("aboutus");
  const [currentPage, setCurrentPage] = useState("history");

  useEffect(() => {
    if (pathname == "/key_statistics") {
      handelCurrentPage("aboutus", "key-statistics");
    }

    if (pathname == "/bus_services") {
      handelCurrentPage("aboutus", "bus-services");
    }

    if (pathname == "/labour_welfare") {
      handelCurrentPage("aboutus", "labour-welfare");
    }

    if (pathname == "/infrastructure_facility") {
      handelCurrentPage("aboutus", "infrastructure-facility");
    }

    if (pathname == "/procurement") {
      handelCurrentPage("aboutus", "procurement");
    }

    if (pathname == "/annual_administration_report") {
      handelCurrentPage("aboutus", "annual-administration-report");
    }

    if (pathname == "/passenger_safety") {
      handelCurrentPage("aboutus", "passenger-safety");
    }

    if (pathname == "/letters_and_circulars") {
      handelCurrentPage("know-more-about", "letters-circulars");
    }

    if (pathname == "/luggage_rates") {
      handelCurrentPage("know-more-about", "luggage-rates");
    }

    if (pathname == "/reservation_terms" || pathname == "/reservation-terms") {
      handelCurrentPage("know-more-about", "reservation-terms");
    }

    if (pathname == "/guest_users_terms" || pathname == "/guest-users-terms") {
      handelCurrentPage("know-more-about", "guest-users-terms");
    }

    if (pathname == "/refund_rules_and_claims" || pathname == "/refund-rules-and-claims") {
      handelCurrentPage("know-more-about", "refund-rules-and-claims");
    }

    if (pathname == "/booking_counters") {
      handelCurrentPage("know-more-about", "booking-counters");
    }

    if (pathname == "/passes_and_concession") {
      handelCurrentPage("know-more-about", "passes-n-concession");
    }

    if (pathname == "/new-franchisee-procedure") {
      handelCurrentPage("franchisee", "new-franchisee");
    }

    if (pathname == "/casual-contact") {
      handelCurrentPage("hireabus", "casual-contact");
    }
  }, [pathname]);

  const handelCurrentPage = (menu, page) => {
    setCurrentMenu(menu);
    setCurrentPage(page);
  };

  // console.log("currentPage", currentPage);

  const loadCurrentPage = () => {
    if (currentPage == "history") {
      return <History />;
    } else if (currentPage == "key-statistics") {
      return <KeyStatistics />;
    } else if (currentPage == "bus-services") {
      return <BusServices />;
    } else if (currentPage == "infrastructure-facility") {
      return <InfrastructureFacility />;
    } else if (currentPage == "annual-administration-report") {
      return <AnnualAdministrationReport />;
    } else if (currentPage == "it-in-ksrtc") {
      return <ItInKsrtc />;
    } else if (currentPage == "financial-performance") {
      return <FinancialPerformance />;
    } else if (currentPage == "labour-welfare") {
      return <LabourWelfare />;
    } else if (currentPage == "procurement") {
      return <Procurement />;
    } else if (currentPage == "passenger-safety") {
      return <PassengerSafety />;
    } else if (currentPage == "management") {
      return <Management />;
    } else if (currentPage == "gst") {
      return <Gst />;
    } else if (currentPage == "awards") {
      return <Awards />;
    } else if (currentPage == "rti-act") {
      return <RtiAct />;
    } else if (currentPage == "letters-circulars") {
      return <LettersNCirculars />;
    } else if (currentPage == "luggage-rates") {
      return <LuggageRates />;
    } else if (currentPage == "reservation-terms") {
      return <ReservationTerms />;
    } else if (currentPage == "guest-users-terms") {
      return window.lang == "en" ? <GuestUsersTerms /> : <GuestUsersTermsKn />;
    } else if (currentPage == "refund-rules-and-claims") {
      return window.lang == "en" ? (
        <RefundRulesAndClaims />
      ) : (
        <RefundRulesAndClaimsKn />
      );
    } else if (currentPage == "booking-counters") {
      return window.lang == "en" ? <BookingCounters /> : <BookingCountersKn />;
    } else if (currentPage == "passes-n-concession") {
      return window.lang == "en" ? (
        <PassesNConcession />
      ) : (
        <PassesNConcessionKn />
      );
    } else if (currentPage == "sakala-services") {
      return window.lang == "en" ? <SakalaServices /> : <SakalaServicesKn />;
    } else if (currentPage == "student-pass") {
      return window.lang == "en" ? <StudentPass /> : <StudentPassKn />;
    } else if (currentPage == "sutp-its") {
      return <SutpIts />;
    } else if (currentPage == "morth-project") {
      return window.lang == "en" ? <MorthProject /> : <MorthProjectKn />;
    } else if (currentPage == "casual-contact") {
      return window.lang == "en" ? <CasualContact /> : <CasualContactKn />;
    } else if (currentPage == "new-franchisee") {
      return window.lang == "en" ? <NewFranchisee /> : <NewFranchiseeKn />;
    } else {
      return <History />;
    }
  };

  return (
    <div className="aboutus--wrapper">
      <HeaderNonSrp />
      <SubHeader />
      <div className="aboutus-content">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "15px 85px",
            background: "#f5f5f5",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: "20px",
              width: "96%",
              background: "#ffffff",
              padding: "20px 10px",
              borderRadius: "10px 10px 0px 0px",
            }}
          >
            <MenuList
              handelCurrentPage={handelCurrentPage}
              currentPage={currentPage}
              currentMenu={currentMenu}
            />
            {loadCurrentPage()}
          </div>
         { !["reservation-terms", "guest-users-terms", "refund-rules-and-claims"].includes(currentPage)  && <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              width: "96%",
              background: "#ffffff",
              padding: "16px 10px 16px 10px",
              height: "60px",
              color: "#444444",
              borderTop: "1px solid lightgrey",
              borderRadius: "0px 0px 10px 10px",
            }}
          >
            Last updated date 21 01-02-2024 03:15 AM
          </div>}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default withRouter(index);
